// Copyright (c) 2020 Comsearch, Inc., All rights reserved

export const initialTableSort = {
  asc: true,
  col: 'createTimestamp',
}
